<app-main-content-card>
  <div class="title-bar">
    <h1>
      {{ "VIP_DISCOUNTS.TITLE_RECEIVED" | translate }}
    </h1>
  </div>
  <p
    *ngIf="
      (discountsReceivedLoading$ | async) === false &&
      !(discountsReceived$ | async)?.length
    "
  >
    {{ "VIP_DISCOUNTS.RECEIVED.EMPTY" | translate }}
  </p>
  <app-vip-discounts-received-table
    *ngFor="let discount of discountsReceived$ | async; let i = index"
    [discount]="discount"
    [tableIndex]="i"
    [showCaptionRow]="i === 0"
  ></app-vip-discounts-received-table>
</app-main-content-card>
